/** The film player's code, loaded only when a page shows a film, as
 *  `live/lazy.tsx` loads the live player: three stays out of the main
 *  bundle (`scripts/check-bundle.mjs`). */
import { lazy } from "react";

export const loadFilmPlayer = () => import("./Player");

/** The player itself (`Player.tsx`'s default export). */
export const LazyFilmPlayer = lazy(loadFilmPlayer);
